export const DRAFT = {
  ADD_SOURCES: 'Add Sources',
  ANALYZE: 'Analyze',
  ANALYZE_REPLY: 'Analyze',
  ANALYZE_AND_PUBLISH: 'Analyze & Publish',
  ANALYZING: 'Analyzing...',
  ANALYZING_REPLY: 'Analyzing...',
  CANCEL: 'Cancel',
  CARD_EDITED_POST_TITLE: 'Changes',
  CLOSE_MODAL: 'Close',
  CREATE_DRAFT: 'Create Draft',
  DELETE_DRAFT: 'Delete',
  EDIT_DRAFT: 'Edit Draft',
  PUBLISH_DRAFT: 'Publish',
  PUBLISH_REPLY: 'Publish',
  SAVE_DRAFT: 'Save Post',
  DONE_EDITING: 'Done Editing',
  SAVE_CHANGES: 'Save Changes',
  SHOW_LAST_ANALYSIS: 'Show Last Analysis',
  EDITED_MODAL: {
    TEXT_ADDED: 'Text Added',
    TEXT_REMOVED: 'Text Removed',
  },
  ANALYSIS_DIALOG: {
    STORY_ANALYSIS_RESULTS: 'Story Analysis Results',
    OVERALL_SCORE: 'Overall Score:',
    SENTIMENT_ANALYSIS: 'Sentiment Analysis',
    SAVE_ANALYSIS_AND_PUBLISH: 'Save Analysis and Publish',
    SAVE_ANALYSIS: 'Save Analysis',
    REVISE_STORY: 'Revise story',
  },
  ADD_SOURCES_DIALOG: {
    TITLE: 'Article Sources for AI Analysis',
    MAX_SOURCES: 5,
    MESSAGE:
      'You can enter up to five sources: news or social media, these will be used as part of the analysis.',
    ADD: 'Add Source(s)',
    CLOSE: 'Close',
    PLACEHOLDER: 'Source...',
    ERROR: {
      INVALID_URL: 'Enter a valid http(s) URL',
    },
  },
  REMOVE_CATEGORY_DIALOG: {
    REMOVE_CATEGORY: 'Remove category',
    CANCEL: 'Cancel',
    REMOVE: 'Remove',
  },
  // TRIL-571 — shared by the post-draft and reply-draft delete confirms so the two
  // surfaces cannot drift. Copy mirrors mobile's confirm (TRIL-543).
  DELETE_DRAFT_DIALOG: {
    TITLE: 'Delete this draft?',
    BODY: 'This cannot be undone.',
    CANCEL: 'Cancel',
    DELETE: 'Delete',
  },
  TRANSITION_ALERT: {
    COOLDOWN_PERIOD_ON:
      "You're in a cooldown period. Please try again in 30 minutes.",
  },
  STATUS: {
    PUBLISHED: 'published',
    UNPUBLISHED: 'draft',
  },
};

/**
 * Maximum file size in bytes (3 MB) for draft images
 */
export const MAX_FILE_SIZE = 3 * 1024 * 1024; // 3MB

/**
 * Allowed image types for draft images
 */
export const ALLOWED_IMAGE_TYPES = [
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/gif',
  'image/webp',
];
